const StartAnonymousVoicecallChat = `mutation StartAnonymousVoicecallChat($accessToken:String!,$actorId:Int!){messenger{startAnonymousVoicecallChat(accessToken:$accessToken,actorId:$actorId){resultCode server clientId}}}`;

const TouchMessengerChannel = `mutation TouchMessengerChannel($actorId:Int!){guest{touchMessengerChannel(actorId:$actorId)}}`;

const GetUnreadMessagesCount = `query GetUnreadMessagesCount{guest{messages{unreadCount}}}`;

const GetMessengerGifts = `query GetMessengerGifts{messenger{gifts{id name price{currency value symbol}imageUrl active vip categoryId translations{language name value}}}}`;

const GetMessengerToyControls = `query GetMessengerToyControls{messenger{toyControls{id name price{currency value symbol}imageUrl active vip categoryId translations{language name value}duration displayName random}}}`;

const GetMessengerContent = `query messengerContent($first:Int!,$offset:Int!,$filter:MessengerContentFilterInput!,$order:String){guest{id messengerContent(first:$first,offset:$offset,filter:$filter,order:$order){items{messageId text date model{name linkVX(internal:true)id avatar{url(size:w60)}}media{type origSrc src srcSet width height duration previewPicture}}total}}}`;

const GetChannels = `query GetChannels($first:Int,$offset:Int,$filter:MessengerChannelsFilterInput){guest{messengerChannels(first:$first,offset:$offset,filter:$filter){items{channelId actorId guestId unreadCount blocked model{name}}total}}}`;

export {
	StartAnonymousVoicecallChat,
	TouchMessengerChannel,
	GetUnreadMessagesCount,
	GetMessengerGifts,
	GetMessengerToyControls,
	GetMessengerContent,
	GetChannels,
};
